import { Close, Lightbulb } from '@mui/icons-material';
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, Grid, IconButton, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import React, { Component } from 'react';
import axios from "axios";
import Global from "../../../customlib/Global";
import Api from "../../../customlib/Api";

class AutoReplySalesOnline extends Component {
    state = { 
        isDialogOpen: false,
        logsAutoReply: [],
        logsLeadsPooling: [],
        isLoadingAutoReplyLog: false,
        isLoadingLeadsPoolingLog: false,
        isLoadingUpdateAutoReplyState: false,
        isLoadingUpdateLeadsPoolingState: false,
        startAt: "",
        endAt: ""
    } 

    loadAutoReplyLogs = () => {
        this.setState({isLoadingLog: true}, () => {
            axios
                .post(Api.getGeneralSettingLogs(), {fieldName: "autoReplyEnabled"}, Api.getRequestHeader())
                .then((response) => {
            
                    console.log("GENERAL_SSETTINGS", response.data);
                
                    var data = response.data;
                
                    this.setState({logsAutoReply: data.data, isLoadingLog: false});
            
                })
                .catch((error) => {
                    this.setState({isLoadingLog: false});
                    console.error("There was an error!", error);
                });
        });
    }

    loadLeadsPoolingLogs = () => {
        this.setState({isLoadingLog: true}, () => {
            axios
                .post(Api.getGeneralSettingLogs(), {fieldName: "leadsPooling"}, Api.getRequestHeader())
                .then((response) => {
            
                    console.log("GENERAL_SSETTINGS", response.data);
                
                    var data = response.data;
                
                    this.setState({logsLeadsPooling: data.data, isLoadingLog: false});
            
                })
                .catch((error) => {
                    this.setState({isLoadingLog: false});
                    console.error("There was an error!", error);
                });
        });
    }

    updateAutoReplyState = (isEnabled) => {
        this.setState({isLoadingUpdateAutoReplyState: true}, () => {
            axios
                .post(Api.updateAutoReplyState(), {enabled: isEnabled}, Api.getRequestHeader())
                .then((response) => {
            
                    console.log("GENERAL_SSETTINGS", response.data);
                    
                    this.setState({isLoadingUpdateAutoReplyState: false}, () => {
                        this.props.onReload();
                        this.loadAutoReplyLogs();
                    });
            
                })
                .catch((error) => {
                    this.setState({isLoadingUpdateAutoReplyState: false});
                    console.error("There was an error!", error);
                });
        });
    }

    updateLeadsPoolingState = (isEnabled) => {
        this.setState({isLoadingUpdateLeadsPoolingState: true}, () => {
            axios
                .post(Api.updateLeadsPoolingState(), {enabled: isEnabled, startAt: this.state.startAt, endAt: this.state.endAt}, Api.getRequestHeader())
                .then((response) => {
            
                    console.log("GENERAL_SSETTINGS", response.data);
                    
                    this.setState({isLoadingUpdateLeadsPoolingState: false}, () => {
                        this.props.onReload();
                        this.loadLeadsPoolingLogs();
                    });
            
                })
                .catch((error) => {
                    this.setState({isLoadingUpdateLeadsPoolingState: false});
                    console.error("There was an error!", error);
                });
        });
    }

    handleShowDialog = () => {
        this.setState({isDialogOpen: true, startAt: this.props?.data?.leadsPooling?.startAt, endAt: this.props?.data?.leadsPooling?.endAt,}, () => {
            this.loadAutoReplyLogs();
            this.loadLeadsPoolingLogs();
        });
    }

    handleCloseDialog = () => {
        this.setState({isDialogOpen: false, logs: []});
    }

    listJam = [
        "01:00", "02:00", "03:00", "04:00",
        "05:00", "06:00", "07:00", "08:00", "09:00",
        "10:00", "11:00", "12:00", "13:00", "14:00",
        "15:00", "16:00", "17:00", "18:00", "19:00",
        "20:00", "21:00", "22:00", "23:00", "24:00",
    ];

    handleStartAtChange = (event) => {
        this.setState({startAt: event.target.value});
    }

    handleEndAtChange = (event) => {
        this.setState({endAt: event.target.value});
    }

    render() { 

        if(!Global.get().admin && !Global.isTeleAdmin()){
        // if(Global.get().admin || Global.isTeleAdmin()){
            return (
                <Paper 
                    sx={{backgroundColor: "#cccacaff", pt: "10px", pb: "10px", pl: "15px", pr: "15px"}}
                >
                    <Grid container spacing={1}>
                        <Grid item xs={10}>
                            <strong>Blast Akun Tele RB</strong>
                        </Grid>
                        <Grid item xs={2}>
                            <Lightbulb color={this.props.data?.fuBlastTeleRBEnabled ? "warning" : "default"} />                                    
                        </Grid>
                    </Grid>
                </Paper> 
            );
        }

        return (
            <Box>
                <Tooltip title={`Auto Reply & Leads Pooling Sales Online (${this.props.data?.fuBlastTeleRBEnabled ? 'ON' : 'OFF'})`}>
                    <Paper 
                        sx={{backgroundColor: "#b9e4f6ff", cursor: "pointer", pt: "10px", pb: "10px", pl: "15px", pr: "15px"}}
                        onClick={this.handleShowDialog}
                    >
                        <Grid container spacing={1}>
                            <Grid item xs={10}>
                                <strong>Auto Reply &amp; Leads Pooling Sales Online</strong>
                            </Grid>
                            <Grid item xs={2}>
                                <Lightbulb color={this.props.data?.autoReplyEnabled ? "warning" : "default"} />                                    
                            </Grid>
                        </Grid>
                    </Paper> 
                </Tooltip> 

                <Dialog
                    open={this.state.isDialogOpen}
                    onClose={this.handleCloseDialog}
                    maxWidth={"xl"}
                    fullWidth
                    
                >
                    <DialogTitle id="alert-dialog-title">
                        
                        <Grid container spacing={1}>
                            <Grid item sm={10} xs={12}>{"Auto Reply & Leads Pooling Sales Online"}</Grid>
                            <Grid item sm={2} xs={12} textAlign={"right"}>
                                <IconButton onClick={this.handleCloseDialog} color='error'><Close /></IconButton>
                            </Grid>
                        </Grid>
                    </DialogTitle>
                    <Divider />
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={6}>
                                    {
                                        this.props.data?.autoReplyEnabled && (
                                            <Grid container spacing={1}>
                                                <Grid item sm={8} xs={12}>Auto Reply sedang <strong>Aktif</strong></Grid>
                                                <Grid item sm={4} xs={12} textAlign={"left"}>
                                                    <Button 
                                                        variant='contained' 
                                                        color='error' 
                                                        sx={{textTransform: "capitalize"}}
                                                        onClick={() => this.updateAutoReplyState(false)}
                                                        disabled={this.state.isLoadingUpdateAutoReplyState}
                                                    >
                                                        Nonaktifkan!
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        )
                                    }

                                    {
                                        !this.props.data?.autoReplyEnabled && (
                                            <Grid container spacing={1}>
                                                <Grid item sm={8} xs={12}>Auto Reply sedang <strong>Tidak Aktif</strong></Grid>
                                                <Grid item sm={4} xs={12} textAlign={"left"}>
                                                    <Button 
                                                        variant='contained' 
                                                        color='primary' 
                                                        sx={{textTransform: "capitalize"}}
                                                        onClick={() => this.updateAutoReplyState(true)}
                                                        disabled={this.state.isLoadingUpdateLeadsPoolingState}
                                                    >
                                                        Aktifkan!
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        )
                                    }
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    {
                                        this.props.data?.leadsPooling?.enabled && (
                                            <Grid container spacing={1}>
                                                <Grid item sm={8} xs={12}>Leads Pooling sedang <strong>Aktif</strong></Grid>
                                                <Grid item sm={12} xs={12} textAlign={"left"}>
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={12} sm={4}>
                                                            <FormControl fullWidth size='small'>
                                                                <InputLabel id="select-startat">Start</InputLabel>
                                                                <Select
                                                                    labelId="select-startat"
                                                                    id="select-startat"
                                                                    value={this.state.startAt}
                                                                    label="Start"
                                                                    onChange={this.handleStartAtChange}
                                                                >
                                                                    {
                                                                        this.listJam.map(item => <MenuItem value={item}>{item}</MenuItem>)
                                                                    }
                                                                    
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid item xs={12} sm={4}>
                                                            <FormControl fullWidth size='small'>
                                                                <InputLabel id="select-endat">Start</InputLabel>
                                                                <Select
                                                                    labelId="select-endat"
                                                                    id="select-endat"
                                                                    value={this.state.endAt}
                                                                    label="End"
                                                                    onChange={this.handleEndAtChange}
                                                                >
                                                                    {
                                                                        this.listJam.map(item => <MenuItem value={item}>{item}</MenuItem>)
                                                                    }
                                                                    
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid item xs={12} sm={4}>
                                                            <Button 
                                                                variant='contained' 
                                                                color='error' 
                                                                sx={{textTransform: "capitalize"}}
                                                                onClick={() => this.updateLeadsPoolingState(false)}
                                                                disabled={this.state.isLoadingUpdateLeadsPoolingState}
                                                            >
                                                                Nonaktifkan!
                                                            </Button>
                                                        </Grid>
                                                </Grid>
                                            </Grid>
                                            </Grid>
                                        )
                                    }

                                    {
                                        !this.props.data?.leadsPooling?.enabled && (
                                            <Grid container spacing={1}>
                                                <Grid item sm={8} xs={12}>Leads Pooling <strong>Tidak Aktif</strong></Grid>
                                                <Grid item sm={12} xs={12} textAlign={"left"}>
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={12} sm={4}>
                                                            <FormControl fullWidth size='small'>
                                                                <InputLabel id="select-startat">Start</InputLabel>
                                                                <Select
                                                                    labelId="select-startat"
                                                                    id="select-startat"
                                                                    value={this.state.startAt}
                                                                    label="Start"
                                                                    onChange={this.handleStartAtChange}
                                                                >
                                                                    {
                                                                        this.listJam.map(item => <MenuItem value={item}>{item}</MenuItem>)
                                                                    }
                                                                    
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid item xs={12} sm={4}>
                                                            <FormControl fullWidth size='small'>
                                                                <InputLabel id="select-endat">Start</InputLabel>
                                                                <Select
                                                                    labelId="select-endat"
                                                                    id="select-endat"
                                                                    value={this.state.endAt}
                                                                    label="End"
                                                                    onChange={this.handleEndAtChange}
                                                                >
                                                                    {
                                                                        this.listJam.map(item => <MenuItem value={item}>{item}</MenuItem>)
                                                                    }
                                                                    
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid item xs={12} sm={4}>
                                                            <Button 
                                                                variant='contained' 
                                                                color='primary' 
                                                                sx={{textTransform: "capitalize"}}
                                                                onClick={() => this.updateLeadsPoolingState(true)}
                                                                disabled={this.state.isLoadingUpdateLeadsPoolingState}
                                                            >
                                                                Aktifkan!
                                                            </Button>
                                                        </Grid>
                                                </Grid>
                                            </Grid>
                                            </Grid>
                                        )
                                    }
                                </Grid>
                            </Grid>
                            
                        </DialogContentText>
                        
                        <Divider sx={{mt: "10px", mb: "10px"}} />
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={6} sx={{borderRight: "solid 1px #dededd"}}>
                                <Typography variant='h6'>Riwayat Auto Reply</Typography>
                                <TableContainer>
                                    <Table size='small'>
                                        <TableHead>
                                            <TableCell><strong>Tag</strong></TableCell>
                                            <TableCell><strong>Action</strong></TableCell>
                                            <TableCell><strong>By</strong></TableCell>
                                            <TableCell><strong>At</strong></TableCell>
                                        </TableHead>
                                        <TableBody>
                                        {
                                            this.state.isLoadingAutoReplyLog && (
                                                <TableRow>
                                                    <TableCell colSpan={4} textAlign={"center"}>Loading ... <CircularProgress size={"15px"} /></TableCell>
                                                </TableRow>
                                            )
                                        }
                                        {
                                            !this.state.isLoadingAutoReplyLog && this.state.logsAutoReply?.map(item => {
                                                return (
                                                    <TableRow>
                                                        <TableCell width={"40%"}>{item.tag}</TableCell>
                                                        <TableCell width={"20%"}>{item.newValue === true ? "Diaktifkan" : "Dinonaktifkan"}</TableCell>
                                                        <TableCell width={"20%"}>{item.executorName}</TableCell>
                                                        <TableCell width={"20%"}>{Global.formatDateTimeToStrDateTime24(item.created_at)}</TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                            <Grid item xs={12} sm={6} sx={{borderLeft: "solid 1px #dededd"}}>
                                <Typography variant='h6'>Riwayat Leads Pooling</Typography>
                                <TableContainer>
                                    <Table size='small'>
                                        <TableHead>
                                            <TableCell><strong>Tag</strong></TableCell>
                                            <TableCell><strong>Action</strong></TableCell>
                                            <TableCell><strong>By</strong></TableCell>
                                            <TableCell><strong>At</strong></TableCell>
                                        </TableHead>
                                        <TableBody>
                                        {
                                            this.state.isLoadingLeadsPoolingLog && (
                                                <TableRow>
                                                    <TableCell colSpan={4} textAlign={"center"}>Loading ... <CircularProgress size={"15px"} /></TableCell>
                                                </TableRow>
                                            )
                                        }
                                        {
                                            !this.state.isLoadingLeadsPoolingLog && this.state.logsLeadsPooling?.map(item => {
                                                return (
                                                    <TableRow>
                                                        <TableCell width={"40%"}>{item.tag}</TableCell>
                                                        <TableCell width={"20%"}>{item.newValue?.enabled === true ? "Diaktifkan" : "Dinonaktifkan"}</TableCell>
                                                        <TableCell width={"20%"}>{item.executorName}</TableCell>
                                                        <TableCell width={"20%"}>{Global.formatDateTimeToStrDateTime24(item.created_at)}</TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                        
                    </DialogContent>
                    <DialogActions>
                    </DialogActions>
                </Dialog>

            </Box>
        );
    }
}
 
export default AutoReplySalesOnline;